import React, { useEffect, useState } from "react";

import "./productGrid.css";

import { Tooltip } from "@mui/material";
import Table from "../../components/table/Table";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllProduct } from "../../redux/features/product.features";
import {
  addEditedInvoice,
  clearEditInvoice,
  fetchAllSales,
} from "../../redux/features/sales.features";
import { showSuccess } from "../../redux/features/alertbox.features";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import IndividualInvoiceViewer from "../Sales/IndividualInvoiceViewer";
import Modal from "../../components/modal/Modal";
import { Box } from "@mui/system";
import EditInvoice from "../Sales/EditInvoice";
const renderHead = (item, index) => (
  <th className="selected" key={index}>
    {item}
  </th>
);

// const finalTableHead = [
//   "Item ID",
//   "title",
//   "category",
//   "description",

//   "date",
//   "clarity",
//   "need_recut",
//   "treatment_type",
//   "origin",
//   "shape",
//   "weight",
//   "dimension",
//   "buyCurrency",
//   "buyPrice",
//   "sellPriceLocal",
//   "sellLocalCurrency",
//   "sellForeignersCurrency",
//   "sellPriceForeigners"

// ];

const ProductGrid = ({ productModalPopUp }) => {
  const [showIndividualInvoiceViewerModal, setIndividualInvoiceShow] =
    useState(false);
  const [showInvoiceEditingModal, setShowInvoiceEditingModal] = useState(false);

  let dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllSales());
  }, [dispatch]);

  let salesState = useSelector((state) => {
    return state.salesReducer;
  });
  let { recentInvoice, invoice, sales, successMessage, errorMessage } =
    salesState;

  let userState = useSelector((state) => {
    return state.userReducer;
  });

  let { user } = userState;

  let productState = useSelector((state) => {
    return state.productReducer;
  });
  useEffect(() => {
    dispatch(fetchAllProduct());
  }, [dispatch]);

  let { products, loading } = productState || { products: [], loading: false };
  const [showInvoice, setShowInvoice] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedInvoice, setselectedInvoice] = useState(null);
  const [tab, setTab] = useState(0);

  const toggleShowInvoice = (id) => {
    setShowInvoice((state) => !state);
    setSelectedId(id);
    let selectedS = sales.filter((x) => x.invoiceNumber === id);
    console.log("selectedSales : ", selectedS);
    setselectedInvoice(selectedS);
  };

  useEffect(() => {}, [products]);

  const onClickEditedInvoice = (data) => {
    let copyObj = {};
    for (let i in data) {
      copyObj[i] = data[i];
    }
    dispatch(addEditedInvoice(copyObj));
    setShowInvoiceEditingModal(true);
  };

  const finalRenderBody = (item, index) => (
    <>
      <tr
        style={{
          color: "#fff",
          backgroundColor: item?.isSold ? "#a20b0b" : "inherit",
        }}
        onClick={() =>
          item?.isSold ? toggleShowInvoice(item.invoiceNumber) : null
        }
        key={index || 0}
      >
        {/* <td>{item.id}</td> */}
        <td>{item.productId}</td>
        <td>{item.title}</td>
        <td>{item.category}</td>
        {/* <td>{item.description}</td> */}
        <td>{item.date}</td>
        <td>{item.clarity}</td>
        <td>{item.need_recut}</td>
        <td>{item.treatment_type}</td>
        <td>{item.origin}</td>
        <td>{item.shape}</td>
        <td>{item.weight}</td>
        <td>
          {item.dimensionHeight +
            "*" +
            item.dimensionWidth +
            "*" +
            item.dimensionDepth}
        </td>
        <td className="text-right">
          {Number(item.buyPrice).toLocaleString()} {item.buyCurrency}
        </td>
        <td className="text-right">
          {Number(item.sellPriceLocal).toLocaleString()}{" "}
          {item.sellLocalCurrency}
        </td>
        <td className="text-right">
          {Number(item.sellPriceForeigners).toLocaleString()}{" "}
          {item.sellForeignersCurrency}
        </td>
      </tr>
      {item.invoiceNumber && showInvoice && selectedId === item.invoiceNumber && (
        <tr className="hover:bg-transparent" key={index * 33}>
          <td colSpan={15} style={{ display: "table-cell" }}>
            <div
              style={{
                width: "77vw",
                display: "flex",
                flexDirection: "column",

                padding: "20px",
              }}
              className=""
              colspan={15}
            >
              <div className="flex justify-between">
                <div className="flex-col items-start">
                  <h4>
                    GRAND TOTAL :{" "}
                    {Number(
                      selectedInvoice[0].invoiceGrandTotal
                    ).toLocaleString()}{" "}
                    {selectedInvoice[0].invoiceCurrency}
                  </h4>
                  <h5>
                    INVOICE CURRENCY : {selectedInvoice[0].invoiceCurrency}
                  </h5>
                </div>
                <div className="text-right flex items-flex-end flex-col w-3/12">
                  <div className="flex justify-between items-center">
                    <h4
                      className="m-3 p-3 hover:bg-green-800 bg-green-500 rounded text-white font-extrabold cursor-pointer"
                      onClick={() => setIndividualInvoiceShow(true)}
                    >
                      INVOICE No. : {selectedInvoice[0].invoiceNumber}
                    </h4>
                    <div
                      onClick={() => onClickEditedInvoice(selectedInvoice[0])}
                      className="bg-red-500 hover:bg-red-800 rounded p-3 bx bx-edit mx-1 text-white font-extrabold cursor-pointer"
                    >
                      {" "}
                      Edit Invoice
                    </div>
                  </div>

                  <h5>
                    INVOICE DATE :{" "}
                    {moment(selectedInvoice[0].invoiceDate).format(
                      "DD-MM-YYYY"
                    )}
                  </h5>
                </div>
              </div>
              <div className="flex justify-between">
                <div className="flex-col items-start">
                  <h4>
                    PAYMENT TYPE : {selectedInvoice[0].invoicePaymentType}
                  </h4>
                  <h5>INVOICE TYPE : {selectedInvoice[0].invoiceType}</h5>
                </div>
                <div className="flex-col items-end">
                  <h4>
                    <div>
                      CUSTOMER :
                      {selectedInvoice[0].invoiceType === "Sales" ? (
                        <span>
                          {selectedInvoice[0].invoiceCustomer &&
                          selectedInvoice[0].invoiceCustomer.length !== 0 &&
                          user.role === "admin"
                            ? selectedInvoice[0].invoiceCustomer[0].firstName
                            : selectedInvoice[0].invoiceCustomer[0].customerId}
                        </span>
                      ) : (
                        <span>
                          {selectedInvoice[0].invoiceBroker &&
                            selectedInvoice[0].invoiceBroker.length !== 0 &&
                            selectedInvoice[0].invoiceBroker[0].firstName}
                        </span>
                      )}
                    </div>
                  </h4>
                  <h5>
                    BALANCE TO RECEIVE :{" "}
                    {Number(
                      selectedInvoice[0].invoiceBalanceToReceived
                    ).toLocaleString()}{" "}
                    {selectedInvoice[0].invoiceCurrency}
                  </h5>
                </div>
              </div>

              <div className="flex items-center p-3">
                STATUS : {selectedInvoice[0].invoiceStatus || "Not Approved"}
                {/* {selectedInvoice[0].invoiceStatus !== "Complete" &&
                  selectedInvoice[0].invoiceStatus !== "Return" &&
                  selectedInvoice[0].invoiceStatus !== "Cancel" && (
                    <div className="flex ">
                      <Tooltip title="Payments are fully completed">
                        <i
                          //  onClick={() => changeToComplete(item)}
                          className=" bg-green-500 m-2 p-2 text-xs font-extrabold text-white rounded"
                        >
                          CML
                        </i>
                      </Tooltip>
                      <Tooltip title="Payments are pending">
                        <i
                          //  onClick={() => changeToPending(item)}
                          className=" bg-red-500 m-2 p-2 text-xs font-extrabold text-white rounded"
                        >
                          PND
                        </i>
                      </Tooltip>
                    </div>
                  )} */}
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );

  const finalTableHead = [
    "Item ID",
    "Title",
    "Category",
    // "Description",
    "Enter Date",
    "Clarity",
    "Re-cut",
    "Treatment",
    "Origin",
    "Shape",
    "Weight",
    "Dimension",
    "Buy Price",
    "Sell Price (Local)",
    "Sell Price (Foreign)",
  ];

  const [data, setData] = useState(products.filter((x) => !x.isSold));
  const navigate = useNavigate();
  return (
    <div style={{ zIndex: "unset" }}>
      <div className="flex w-full my-3 ">
        <button
          onClick={productModalPopUp}
          className="w-4/12 uppercase  m-2 rounded p-4  hover:bg-green-700 bg-green-500 text-white font-bold flex justify-between items-center"
        >
          <span className="text-white font-extrabold bx bx-layer-plus text-4xl"></span>
          Add New Item
        </button>
        <button
          onClick={() => {setData(products.filter((x) => !x.isSold)); setTab(0)}}
          className="w-4/12 uppercase   m-2 rounded p-4 text-white bg-green-500 hover:bg-green-700 flex justify-between items-center"
          style={{backgroundColor: tab===0 ? 'var(--bg-dark)' : '', border: tab===0 ? '2px solid white' : 'none'}}
        >
          <span className="text-white font-extrabold bx bx-layer text-4xl"></span>  Available Items ({products.filter((x) => !x.isSold).length})
        </button>
        <button
          style={{backgroundColor: tab===1 ? 'var(--bg-dark)' : '', border: tab===1 ? '2px solid white' : 'none'}}

          onClick={() => {setData(products); setTab(1)}}
          className="w-4/12 uppercase flex justify-between items-center m-2 rounded p-4 bg-green-500 hover:bg-green-700 text-white font-bold  "
        >
           
           <span className="text-white font-extrabold bx bx-package text-4xl"></span> All Items ({products.length})
        </button>
        <button
          onClick={() => navigate("/product-management")}
          className="w-4/12 uppercase flex justify-between items-center m-2 rounded p-4 bg-green-500 hover:bg-green-700 text-white font-bold  "
        >
           
           <span className="text-white font-extrabold bx bx-notepad text-4xl"></span> MANAGE ALL ITEMS
        </button>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card__body">
              {loading ? (
                <p>loading...</p>
              ) : (
                <Table
                  showLimit
                  showSearch
                  limit="100"
                  headData={finalTableHead}
                  renderHead={(item, index) => renderHead(item, index)}
                  bodyData={data}
                  renderBody={(item, index) => finalRenderBody(item, index)}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal
        modal_title={"INVOICE VIEWER"}
        canShow={showIndividualInvoiceViewerModal}
        updateModalState={() => {
          setIndividualInvoiceShow(false);
        }}
      >
        <Box>
          <IndividualInvoiceViewer
            invoice={selectedInvoice !== null ? selectedInvoice[0] : {}}
          />
        </Box>
      </Modal>

      <Modal
        modal_title={"Edit Invoice"}
        canShow={showInvoiceEditingModal}
        updateModalState={() => {
          setShowInvoiceEditingModal((state) => !state);
        }}
      >
        <Box>
          <EditInvoice
            cancel={() => {
              setShowInvoiceEditingModal((state) => !state);
              dispatch(clearEditInvoice());
            }}
    onClose = {() => {
      setShowInvoiceEditingModal((state) => !state);
      dispatch(clearEditInvoice());
    }}

          />
        </Box>
      </Modal>
    </div>
  );
};

export default ProductGrid;
